import router from '~/core/router';
import {
  ForgotPasswordRoute,
  ResetPasswordRoute,
  SignInRoute,
  SignUpRoute,
} from '~/modules/auth';

router.addAuthRoutes([
  SignInRoute,
  SignUpRoute,
  ForgotPasswordRoute,
  ResetPasswordRoute,
]);
